import { useMemo } from 'react';
import { usePrintedAST, textNodeToJsxPrinter, makeHtmlNodeToJsxPrinter, generateJsxKey } from '@utils/ast';
import { usePageContext } from '../../../../context.js';
import { CircledAudioPlayer } from '../../../atom.audio/_audio-player.circled.js';
import { IntroductionSplitView } from '../../molecule.introduction/container.split-view.js';
import { linebreak, splitviewWrapper, wrapper } from './_task.in-text.style.js';
import { WriteAnswersFractionInput } from './input.fraction.js';
import { WriteAnswersTextInput } from './input.text.js';
import { jsx } from 'react/jsx-runtime';

function isLastInputNode(node, context) {
  if (context.parentNode) {
    return false;
  }
  const inputSiblings = context.siblingNodes.filter(it => it.nodeType !== "text" && it.nodeType !== "html");
  return inputSiblings.indexOf(node) === inputSiblings.length - 1;
}
function WriteAnswersInTextTask(props) {
  const pageContext = usePageContext();

  // See ADO #113218
  const shouldCenterContent = useMemo(() => props.task.content.filter(it => it.nodeType !== "text" || it.value.trim()).every(node => node.nodeType !== "html" && node.nodeType !== "text"), [props.task.content]);
  const content = usePrintedAST(props.task.content, {
    text: textNodeToJsxPrinter,
    html: makeHtmlNodeToJsxPrinter({
      skipLeadingBRs: true,
      skipTrailingBRs: true,
      handleTag(tag, data, context) {
        switch (tag) {
          case "br":
            return /*#__PURE__*/jsx("span", {
              className: linebreak,
              children: " "
            }, generateJsxKey(context));
        }
      }
    }),
    "text-input": (node, context) => /*#__PURE__*/jsx(WriteAnswersTextInput, {
      node: node,
      taskEntryKey: props.taskEntryKey,
      isOnlyInput: props.task.content.filter(it => it.nodeType !== "text" || !!it.value.trim()).length === 1,
      isLastInput: isLastInputNode(node, context)
    }, generateJsxKey(context)),
    "fraction-input": (node, context) => /*#__PURE__*/jsx(WriteAnswersFractionInput, {
      node: node,
      taskEntryKey: props.taskEntryKey,
      isLastInput: isLastInputNode(node, context)
    }, generateJsxKey(context)),
    "inline-audio": (node, context) => /*#__PURE__*/jsx(CircledAudioPlayer, {
      src: node.src
    }, generateJsxKey(context))
  });
  return /*#__PURE__*/jsx(IntroductionSplitView, {
    className: splitviewWrapper,
    task: props.task,
    children: /*#__PURE__*/jsx("div", {
      className: wrapper,
      "data-page-context": pageContext,
      "data-centered": shouldCenterContent,
      children: content
    })
  });
}

export { WriteAnswersInTextTask };
//# sourceMappingURL=_task.in-text.js.map
